module.exports = __webpack_public_path__ + "./images/Espectaculo.f2040937f172efb03ea7affa93f4a4f2.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Espectaculo.png
// module id = ./websources/public/images/Espectaculo.png
// module chunks = 0